import { render } from "./SelectCommand.vue?vue&type=template&id=558234e3&scoped=true"
import script from "./SelectCommand.vue?vue&type=script&lang=js"
export * from "./SelectCommand.vue?vue&type=script&lang=js"

import "./SelectCommand.vue?vue&type=style&index=0&id=558234e3&scoped=true&lang=css"

import exportComponent from "../../../../../biotron-pwa-ux-runtime/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-558234e3"]])

export default __exports__